import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VehiclePanelOption } from 'src/app/shared/models/configuration';

import { vehiclePanelOptions } from 'src/app/vehicles/models/vehicle-panel-option';
import { LocalStorageData } from 'src/app/profile-config/user-config/components/user-card-vehicle/models/user-card.model';
import { MapService } from 'src/app/vehicles/services/map.service';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { ConfigKeys } from 'src/app/shared/models/configuration';

@Injectable({
  providedIn: 'root',
})
export class StateCustomPanelVehicleService {
  private shoNameItemButtonSubject = new BehaviorSubject<boolean>(true);
  showNameItemButton$ = this.shoNameItemButtonSubject.asObservable();

  public optionConfiguration = new BehaviorSubject<VehiclePanelOption>(vehiclePanelOptions);
  optionConfiguration$ = this.optionConfiguration.asObservable();

  private showInternalCodeItemButtonSubject = new BehaviorSubject<boolean>(
    false
  );
  showInternalCodeItemButton$ =
    this.showInternalCodeItemButtonSubject.asObservable();

  private showNamePlateItemButtonSubject = new BehaviorSubject<boolean>(false);
  showNamePlateItemButton$ = this.showNamePlateItemButtonSubject.asObservable();

  private showCheckboxSubject = new BehaviorSubject<boolean>(true);
  showCheckbox$ = this.showCheckboxSubject.asObservable();

  private showFixedCollectionSubject = new BehaviorSubject<boolean>(false);
  showFixedCollection$ = this.showFixedCollectionSubject.asObservable();

  private showColorStatusSubject = new BehaviorSubject<boolean>(true);
  showColorStatus$ = this.showColorStatusSubject.asObservable();

  private showIconVehicleSubject = new BehaviorSubject<boolean>(true);
  showIconVehicle$ = this.showIconVehicleSubject.asObservable();

  private showImeiSubject = new BehaviorSubject<boolean>(false);
  showImei$ = this.showImeiSubject.asObservable();

  private showNumSimSubject = new BehaviorSubject<boolean>(false);
  showNumSim$ = this.showNumSimSubject.asObservable();

  private showDriverButtonSubject = new BehaviorSubject<boolean>(false);
  showDriverButton$ = this.showDriverButtonSubject.asObservable();

  private showNameButtonSubject = new BehaviorSubject<boolean>(false);
  showNameButton$ = this.showNameButtonSubject.asObservable();

  private showFollowUnitButtonSubject = new BehaviorSubject<boolean>(true);
  showFollowUnitButton$ = this.showFollowUnitButtonSubject.asObservable();

  private showConfigurationButtonSubject = new BehaviorSubject<boolean>(false);
  showConfigurationButton$ = this.showConfigurationButtonSubject.asObservable();

  private showSpeedSubject = new BehaviorSubject<boolean>(true);
  showSpeed$ = this.showSpeedSubject.asObservable();

  private batteryVoltageSubject = new BehaviorSubject<boolean>(false);
  batteryVoltage$ = this.batteryVoltageSubject.asObservable();

  private showAmountOfFuelSubject = new BehaviorSubject<boolean>(false);
  showAmountOfFuel$ = this.showAmountOfFuelSubject.asObservable();

  private showTransmissionStatusSubject = new BehaviorSubject<boolean>(true);
  showTransmissionStatus$ = this.showTransmissionStatusSubject.asObservable();

  private showTimeElapsedSubject = new BehaviorSubject<boolean>(true);
  showTimeElapsed$ = this.showTimeElapsedSubject.asObservable();

  private showIgnitionStatusSubject = new BehaviorSubject<boolean>(false);
  showIgnitionStatus$ = this.showIgnitionStatusSubject.asObservable();

  private showSatelliteCountSubject = new BehaviorSubject<boolean>(false);
  showSatelliteCount$ = this.showSatelliteCountSubject.asObservable();

  private showEyeButtonSubject = new BehaviorSubject<boolean>(true);
  showEyeButton$ = this.showEyeButtonSubject.asObservable();

  private showTemperatureBleSubject = new BehaviorSubject<boolean>(false);
  showTemperatureBle$ = this.showTemperatureBleSubject.asObservable();

  private showTemperatureEyeSubject = new BehaviorSubject<boolean>(false);
  showTemperatureEye$ = this.showTemperatureEyeSubject.asObservable();

  private showHumidityBleSubject = new BehaviorSubject<boolean>(false);
  showHumidityBle$ = this.showHumidityBleSubject.asObservable();

  private showHumidityEyeSubject = new BehaviorSubject<boolean>(false);
  showHumidityEye$ = this.showHumidityEyeSubject.asObservable();

  public allHidden : boolean = false;
  public setOptionConfiguration(config : VehiclePanelOption) {
    this.allHidden = this.areAllOptionConfiguration(config)
    this.optionConfiguration.next(config)
  }

  public areAllOptionConfiguration(config : VehiclePanelOption): boolean {
    const items = Object.values(config);
    let allInvisible = true;
    items.forEach(item => {
      if (item.visible) allInvisible = false;
    });
    return allInvisible;
  }

  private showHistoryButtonSubject = new BehaviorSubject<boolean>(true);
  showHistoryButton$ = this.showHistoryButtonSubject.asObservable();

  private showCommandButtonSubject = new BehaviorSubject<boolean>(false);
  showCommandButton$ = this.showCommandButtonSubject.asObservable();

  private showNameDriverSubject = new BehaviorSubject<boolean>(false);
  showNameDriver$ = this.showNameDriverSubject.asObservable();

  constructor(
    private mapService: MapService,
    private vehicleService: VehicleService
  ) {
    // Inicialización si es necesario
    // this.loadConfiguration();
  }

  setShowNameDriver(value: boolean) {
    this.showNameDriverSubject.next(value);
  }

  setShowHistoryButton(value: boolean) {
    this.showHistoryButtonSubject.next(value);
  }

  setShowCommandButton(value: boolean) {
    this.showCommandButtonSubject.next(value);
  }

  setShowNameItemButton(value: boolean) {
    if (value) {
      this.showInternalCodeItemButtonSubject.next(false);
      this.showNamePlateItemButtonSubject.next(false);
    }
    this.shoNameItemButtonSubject.next(value);
  }

  setShowInternalCodeItemButton(value: boolean) {
    if (value) {
      this.shoNameItemButtonSubject.next(false);
      this.showNamePlateItemButtonSubject.next(false);
    }
    this.showInternalCodeItemButtonSubject.next(value);
  }

  setShowNamePlateItemButton(value: boolean) {
    if (value) {
      this.shoNameItemButtonSubject.next(false);
      this.showInternalCodeItemButtonSubject.next(false);
    }
    this.showNamePlateItemButtonSubject.next(value);
  }

  getShowHistoryButton() {
    return this.showHistoryButtonSubject.value;
  }

  getShowCommandButton() {
    return this.showCommandButtonSubject.value;
  }

  getShowNameDriver() {
    return this.showNameDriverSubject.value;
  }

  getShowNameItemButton() {
    return this.showNamePlateItemButtonSubject.value;
  }

  getShowInternalCodeItemButton() {
    return this.showInternalCodeItemButtonSubject.value;
  }

  getShowNamePlateItemButton() {
    return this.showNamePlateItemButtonSubject.value;
  }

  getShowCheckbox() {
    return this.showCheckboxSubject.value;
  }

  getShowFixedCollection() {
    return this.showFixedCollectionSubject.value;
  }

  getShowColorStatus() {
    return this.showColorStatusSubject.value;
  }

  getShowIconVehicle() {
    return this.showIconVehicleSubject.value;
  }

  getShowImei() {
    return this.showImeiSubject.value;
  }

  getShowNumSim() {
    return this.showNumSimSubject.value;
  }

  getShowDriverButton() {
    return this.showDriverButtonSubject.value;
  }

  getShowNameButton() {
    return this.showNameButtonSubject.value;
  }

  getShowFollowUnitButton() {
    return this.showFollowUnitButtonSubject.value;
  }

  getShowConfigurationButton() {
    return this.showConfigurationButtonSubject.value;
  }

  getShowSpeed() {
    return this.showSpeedSubject.value;
  }

  getShowBatteryVoltage() {
    return this.batteryVoltageSubject.value;
  }

  getShowAmountOfFuel() {
    return this.showAmountOfFuelSubject.value;
  }

  getShowTransmissionStatus() {
    return this.showTransmissionStatusSubject.value;
  }

  getShowTimeElapsed() {
    return this.showTimeElapsedSubject.value;
  }

  getShowIgnitionStatus() {
    return this.showIgnitionStatusSubject.value;
  }

  getShowSatelliteCount() {
    return this.showSatelliteCountSubject.value;
  }

  getShowEyeButton() {
    return this.showEyeButtonSubject.value;
  }

  getShowTemperatureBle() {
    return this.showTemperatureBleSubject.value;
  }

  getShowTemperatureEye() {
    return this.showTemperatureEyeSubject.value;
  }

  getShowHumidityBle() {
    return this.showHumidityBleSubject.value;
  }

  getShowHumidityEye() {
    return this.showHumidityEyeSubject.value;
  }

  setShowHumidityBle(value: boolean) {
    this.showHumidityBleSubject.next(value);
  }

  setShowHumidityEye(value: boolean) {
    this.showHumidityEyeSubject.next(value);
  }

  setShowTemperatureBle(value: boolean) {
    this.showTemperatureBleSubject.next(value);
  }

  setShowTemperatureEye(value: boolean) {
    this.showTemperatureEyeSubject.next(value);
  }

  setShowCheckbox(value: boolean) {
    this.showCheckboxSubject.next(value);
  }

  setShowFixedCollection(value: boolean) {
    this.showFixedCollectionSubject.next(value);
  }

  setShowColorStatus(value: boolean) {
    this.showColorStatusSubject.next(value);
  }

  setShowIconVehicle(value: boolean) {
    this.showIconVehicleSubject.next(value);
  }

  setShowImei(value: boolean) {
    this.showImeiSubject.next(value);
  }

  setShowNumSim(value: boolean) {
    this.showNumSimSubject.next(value);
  }

  setShowDriverButton(value: boolean) {
    this.showDriverButtonSubject.next(value);
  }

  setShowNameButton(value: boolean) {
    this.showNameButtonSubject.next(value);
  }

  setShowFollowUnitButton(value: boolean) {
    this.showFollowUnitButtonSubject.next(value);
  }

  setShowConfigurationButton(value: boolean) {
    this.showConfigurationButtonSubject.next(value);
  }

  setShowSpeed(value: boolean) {
    this.showSpeedSubject.next(value);
  }

  setShowBatteryVoltage(value: boolean) {
    this.batteryVoltageSubject.next(value);
  }

  setShowAmountOfFuel(value: boolean) {
    this.showAmountOfFuelSubject.next(value);
  }

  setShowTransmissionStatus(value: boolean) {
    this.showTransmissionStatusSubject.next(value);
  }

  setShowTimeElapsed(value: boolean) {
    this.showTimeElapsedSubject.next(value);
  }

  setShowIgnitionStatus(value: boolean) {
    this.showIgnitionStatusSubject.next(value);
  }

  setShowSatelliteCount(value: boolean) {
    this.showSatelliteCountSubject.next(value);
  }

  setShowEyeButton(value: boolean) {
    this.showEyeButtonSubject.next(value);
  }

  private loadConfiguration(): void {
    const savedConfig = localStorage.getItem(ConfigKeys.VEHICLE_CARD);
    if (savedConfig) {
      const parsedConfig: LocalStorageData = JSON.parse(savedConfig);
      this.saveConfigurationInService(parsedConfig);
      this.saveTabConfiguration(parsedConfig.activeTab);
    }
  }
  public activeTabConf : string = "nombre";

  public setConfigurationPanel(parsedConfig : LocalStorageData) {
    this.activeTabConf = parsedConfig.activeTab;
    console.log("set configuration stat custom panel vehicle ", this.activeTabConf)
    this.saveConfigurationInService(parsedConfig);
    this.saveTabConfiguration(parsedConfig.activeTab);
  }

  private saveConfigurationInService(config: LocalStorageData): void {
    this.setShowImei(config.showIMEI);
    this.setShowNumSim(config.showSIM);
    this.setShowColorStatus(config.showColorStatus);
    this.setShowIgnitionStatus(config.showIgnitionStatus);
    this.setShowSpeed(config.showSpeed);
    this.setShowBatteryVoltage(config.showBatteryVoltage);
    this.setShowAmountOfFuel(config.showFuel);
    this.setShowTimeElapsed(config.showElapsedTime);
    this.setShowSatelliteCount(config.showSatellites);
    this.setShowTemperatureBle(config.showTemperatureBLE);
    this.setShowTemperatureEye(config.showTemperatureEYE);
    this.setShowHumidityBle(config.showHumidityBLE);
    this.setShowHumidityEye(config.showHumidityEYE);
    this.setShowIconVehicle(config.showVehicleIcon);
    this.setShowNameDriver(config.showDriverName);
    this.setShowHistoryButton(config.showHistoryButton);
    this.setShowCommandButton(config.showCommandButton);
    this.setShowDriverButton(config.showDriverButton);
    this.setShowNameButton(config.showNameButton);
    this.setShowFollowUnitButton(config.showFollowButton);
    this.setShowEyeButton(config.showVisualizationButton);
  }

  private saveTabConfiguration(activeTab: string): void {
    switch (activeTab) {
      case 'nombre': {
        this.setShowNameItemButton(true);
        this.mapService.changeNameVehicles('Nombre');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.name_old;
            return vehicle;
          }
        );
        break;
      }
      case 'codigo': {
        this.setShowInternalCodeItemButton(true);
        this.mapService.changeNameVehicles('cod_interno');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.cod_interno!;
            return vehicle;
          }
        );
        break;
      }
      case 'placa': {
        this.setShowNamePlateItemButton(true);
        this.mapService.changeNameVehicles('num_plate');
        this.vehicleService.vehicles = this.vehicleService.vehicles.map(
          (vehicle) => {
            vehicle.name = vehicle.plate_number!;
            return vehicle;
          }
        );
        break;
      }
      default: {
        console.log('Revisar los value que brindaste en options');
      }
    }
  }

  public getConfigurationPanel(): LocalStorageData {
  return {
    showIMEI: this.getShowImei(),
    showSIM: this.getShowNumSim(),
    showColorStatus: this.getShowColorStatus(),
    showIgnitionStatus: this.getShowIgnitionStatus(),
    showSpeed: this.getShowSpeed(),
    showBatteryVoltage: this.getShowBatteryVoltage(),
    showFuel: this.getShowAmountOfFuel(),
    showElapsedTime: this.getShowTimeElapsed(),
    showSatellites: this.getShowSatelliteCount(),
    showTemperatureBLE: this.getShowTemperatureBle(),
    showTemperatureEYE: this.getShowTemperatureEye(),
    showHumidityBLE: this.getShowHumidityBle(),
    showHumidityEYE: this.getShowHumidityEye(),
    showVehicleIcon: this.getShowIconVehicle(),
    showDriverName: this.getShowNameDriver(),
    showHistoryButton: this.getShowHistoryButton(),
    showCommandButton: this.getShowCommandButton(),
    showDriverButton: this.getShowDriverButton(),
    showNameButton: this.getShowNameButton(),
    showFollowButton: this.getShowFollowUnitButton(),
    showVisualizationButton: this.getShowEyeButton(),
    activeTab: this.activeTabConf, // si tienes método para obtenerlo
  };
}

}
